import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { GetAdminHelpersAction } from "../../actions/AdminActions/AdminHelperActions";

interface AdminHelperState {
    addons: any[];
    ctrs: any[];
    plans: any[];
    businesses: any[];
    config: Record<string, any>;
    keys: Record<string, any>;
    scans: any[];
    users: any[];
    loading: boolean;
    error: string | null;
}

const initialState: AdminHelperState = {
    addons: [],
    ctrs: [],
    plans: [],
    businesses: [],
    config: {},
    keys: {},
    scans: [],
    users: [],
    loading: false,
    error: null,
};



const AdminHelperSlice = createSlice({
    name: "adminHelper",
    initialState,
    reducers: {
    },
    extraReducers: (builder) => {
        builder
            .addCase(GetAdminHelpersAction.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(GetAdminHelpersAction.fulfilled, (state, action: PayloadAction<any>) => {
                state.loading = false;
                state.error = null;

                const data = action.payload?.data || {};

                state.addons = data.Addons || [];
                state.ctrs = data.Ctrs || [];
                state.plans = data.plans || [];
                state.businesses = data.businessess || [];
                state.config = data.config || {};
                state.keys = data.keys || {};
                state.scans = data.scans || [];
                state.users = data.users || [];
            })
            .addCase(GetAdminHelpersAction.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload as string;
            });
    },
});

export default AdminHelperSlice.reducer;
